import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Apollo } from 'apollo-angular';
import { combineLatest, ReplaySubject, Subject } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import {
  AVAILABLE_CUSTOMERS_QUERY,
  AvailableCustomerModel,
  AvailableCustomersResponse,
} from './customer-selector.query';

@Injectable()
export class CustomerSelectorService {
  searchValue$ = new Subject<string>();
  private _customers$ = new ReplaySubject<AvailableCustomerModel[]>(1);
  filteredItems$ = combineLatest([
    this._customers$,
    this.searchValue$.pipe(startWith('')),
  ]).pipe(
    map(([items, str]) =>
      items.filter((item) =>
        [item.fullName, item.aliasName]
          .join(' ')
          .toLowerCase()
          .includes(str.toLowerCase())
      )
    )
  );

  constructor(
    private snackBar: MatSnackBar,
    private readonly apollo: Apollo
  ) {
    this._getCustomers().subscribe(this._customers$);
  }

  private _getCustomers() {
    return this.apollo
      .query<AvailableCustomersResponse>({
        query: AVAILABLE_CUSTOMERS_QUERY,
      })
      .pipe(
        map((res) => res?.data?.availableCustomers),
        catchError((err) => {
          const message = $localize`There was an unexpected error.`;
          this.snackBar.open(message, $localize`Close`, { duration: 10000 });
          throw err;
        })
      );
  }
}
